// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion"; // ✅ 新增

// export default function ContactFormSection() {
//   const [showThankYou, setShowThankYou] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // 可选：这里可以加真正的提交逻辑
//     e.target.reset();
//     setShowThankYou(true);
//   };

//   return (
//     <section className="relative z-10 mb-20">
//       {/* Map / Banner Image */}
//       <div className="h-108 w-full relative">
//         <img
//           src="/abstract.jpg"
//           alt="Location"
//           className="w-full h-[420px] object-cover shadow-[0_18px_60px_rgba(138,79,255,0.25)]"
//         />
//       </div>

//       {/* Form Card */}
//       <div className="max-w-4xl mx-auto -mt-56 bg-white text-[#2a0f4c] px-6 sm:px-8 py-8 rounded-3xl shadow-[0_18px_60px_rgba(138,79,255,0.25)] border border-white/70 backdrop-blur-2xl relative z-20">
//         <h2 className="text-2xl md:text-3xl font-extrabold mb-2 text-center bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
//           Send us a message
//         </h2>
//         <p className="text-sm md:text-base text-[#5e4ca8] text-center mb-8">
//           Don&apos;t hesitate to get in touch with us – we&apos;ll be happy to talk to you!
//         </p>

//         <form
//           className="grid md:grid-cols-2 gap-4 md:gap-6"
//           onSubmit={handleSubmit}
//         >
//           {/* ...原来的表单内容保持不动... */}

//           <div>
//             <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
//               Name
//             </label>
//             <input
//               type="text"
//               placeholder="Your Name"
//               className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
//               required
//             />
//           </div>

//           <div>
//             <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
//               Company
//             </label>
//             <input
//               type="text"
//               placeholder="Your Company"
//               className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
//               Email
//             </label>
//             <input
//               type="email"
//               placeholder="Your Email"
//               className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
//               required
//             />
//           </div>

//           <div>
//             <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
//               Phone
//             </label>
//             <input
//               type="tel"
//               placeholder="Your Phone"
//               className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
//             />
//           </div>

//           <div className="md:col-span-2">
//             <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
//               Subject
//             </label>
//             <input
//               type="text"
//               placeholder="Subject"
//               className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
//             />
//           </div>

//           <div className="md:col-span-2">
//             <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
//               Message
//             </label>
//             <textarea
//               placeholder="Your Message"
//               rows={4}
//               className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition resize-none"
//               required
//             ></textarea>
//           </div>

//           <div className="md:col-span-2 text-center mt-2">
//             <button
//               type="submit"
//               className="inline-flex items-center justify-center bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 px-8 py-3 rounded-full font-semibold text-white shadow-[0_10px_30px_rgba(138,79,255,0.4)] transition-transform duration-200 hover:-translate-y-0.5"
//             >
//               Send Message
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* THANK YOU Pop-up ✅ 加动画 */}
//       <AnimatePresence>
//         {showThankYou && (
//           <motion.div
//             className="fixed inset-0 z-30 flex items-center justify-center bg-black/40"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             <motion.div
//               className="bg-white rounded-3xl px-8 py-6 max-w-sm w-[90%] text-center shadow-[0_18px_50px_rgba(15,23,42,0.45)]"
//               initial={{ scale: 0.9, opacity: 0, y: 10 }}
//               animate={{ scale: 1, opacity: 1, y: 0 }}
//               exit={{ scale: 0.9, opacity: 0, y: 10 }}
//               transition={{ duration: 0.2, ease: "easeOut" }}
//             >
//               <h3 className="text-lg md:text-xl font-extrabold mb-2 bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
//                 THANK YOU FOR YOUR MESSAGE
//               </h3>
//               <p className="text-sm text-[#4b3c88] mb-5">
//                 We&apos;ve received your inquiry and will get back to you as soon as
//                 possible.
//               </p>
//               <button
//                 onClick={() => setShowThankYou(false)}
//                 className="inline-flex items-center justify-center px-6 py-2 rounded-full bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold shadow-[0_8px_20px_rgba(88,28,135,0.45)] transition"
//               >
//                 Close
//               </button>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </section>
//   );
// }
// src/components/ContactFormSection.jsx  （路径按你项目实际调整）
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // ✅ 确认路径正确：如果在同级就用 "./firebase"

export default function ContactFormSection() {
  const [showThankYou, setShowThankYou] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    try {
      setLoading(true);

      // 写入 Firestore 的 "mail" 集合（名字要和 Trigger Email 扩展配置一致）
      await addDoc(collection(db, "mail"), {
        to: ["dimension.solutions.tech@gmail.com"], // 收件人
        cc: [form.email],
        replyTo: form.email,                        // 方便直接回复访客
        message: {
          subject: form.subject || `New message from ${form.name || "Website"}`,
          text: `
            Name: ${form.name}
            Company: ${form.company}
            Email: ${form.email}
            Phone: ${form.phone}

            Message:
            ${form.message}
          `,
          html: `
            <h3>New message from AI NOVA website</h3>
            <p><b>Name:</b> ${form.name}</p>
            <p><b>Company:</b> ${form.company}</p>
            <p><b>Email:</b> ${form.email}</p>
            <p><b>Phone:</b> ${form.phone}</p>
            <p><b>Message:</b><br/>${form.message.replace(/\n/g, "<br/>")}</p>
          `,
        },
        createdAt: serverTimestamp(),
      });

      // 清空表单并显示 Thank You
      setForm({
        name: "",
        company: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setShowThankYou(true);
    } catch (err) {
      console.error("send mail error: ", err);
      alert("Sending failed, please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative z-10 mb-20">
      {/* Map / Banner Image */}
      <div className="h-108 w-full relative">
        <img
          src="/abstract.jpg"
          alt="Location"
          className="w-full h-[420px] object-cover shadow-[0_18px_60px_rgba(138,79,255,0.25)]"
        />
      </div>

      {/* Form Card */}
      <div className="max-w-4xl mx-auto -mt-56 bg-white text-[#2a0f4c] px-6 sm:px-8 py-8 rounded-3xl shadow-[0_18px_60px_rgba(138,79,255,0.25)] border border-white/70 backdrop-blur-2xl relative z-20">
        <h2 className="text-2xl md:text-3xl font-extrabold mb-2 text-center bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
          Send us a message
        </h2>
        <p className="text-sm md:text-base text-[#5e4ca8] text-center mb-8">
          Don&apos;t hesitate to get in touch with us – we&apos;ll be happy to talk to you!
        </p>

        <form
          className="grid md:grid-cols-2 gap-4 md:gap-6"
          onSubmit={handleSubmit}
        >
          <div>
            <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
              Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
              required
              value={form.name}
              onChange={handleChange}
            />
          </div>

          <div>
            <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
              Company
            </label>
            <input
              type="text"
              name="company"
              placeholder="Your Company"
              className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
              value={form.company}
              onChange={handleChange}
            />
          </div>

          <div>
            <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
              Email
            </label>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
              required
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div>
            <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
              Phone
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
              value={form.phone}
              onChange={handleChange}
            />
          </div>

          <div className="md:col-span-2">
            <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
              Subject
            </label>
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition"
              value={form.subject}
              onChange={handleChange}
            />
          </div>

          <div className="md:col-span-2">
            <label className="block mb-1 text-xs font-semibold tracking-wide text-[#7b5cff] uppercase">
              Message
            </label>
            <textarea
              name="message"
              placeholder="Your Message"
              rows={4}
              className="w-full bg-purple-50/60 border border-purple-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-300/70 px-3 py-3 rounded-xl text-[#2a0f4c] placeholder-purple-300 outline-none transition resize-none"
              required
              value={form.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="md:col-span-2 text-center mt-2">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 px-8 py-3 rounded-full font-semibold text-white shadow-[0_10px_30px_rgba(138,79,255,0.4)] transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>

      {/* THANK YOU Pop-up */}
      <AnimatePresence>
        {showThankYou && (
          <motion.div
            className="fixed inset-0 z-30 flex items-center justify-center bg-black/40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-3xl px-8 py-6 max-w-sm w-[90%] text-center shadow-[0_18px_50px_rgba(15,23,42,0.45)]"
              initial={{ scale: 0.9, opacity: 0, y: 10 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 10 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              <h3 className="text-lg md:text-xl font-extrabold mb-2 bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
                THANK YOU FOR YOUR MESSAGE
              </h3>
              <p className="text-sm text-[#4b3c88] mb-5">
                We&apos;ve received your inquiry and will get back to you as soon as
                possible.
              </p>
              <button
                onClick={() => setShowThankYou(false)}
                className="inline-flex items-center justify-center px-6 py-2 rounded-full bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold shadow-[0_8px_20px_rgba(88,28,135,0.45)] transition"
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
